<template>
  <svg
    id="Duotone"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 112">
    <title>05- service-3</title>
    <g id="Icons">
      <g id="Background">
        <circle
          class="cls-1"
          cx="50.49"
          cy="56"
          r="40" />
      </g>
      <g id="Scene">
        <rect
          class="cls-2"
          x="39.94"
          y="49.39"
          width="20.7"
          height="26.22" />
        <ellipse
          class="cls-3"
          cx="49.94"
          cy="90.4"
          rx="9.2"
          ry="1.73" />
        <circle
          class="cls-2"
          cx="50.29"
          cy="33.52"
          r="10.35" />
        <circle
          class="cls-4"
          cx="50.29"
          cy="33.52"
          r="10.35" />
        <path
          class="cls-2"
          d="M38.56,46.63H62a0,0,0,0,1,0,0v1.56a1.2,1.2,0,0,1-1.2,1.2H39.76a1.2,1.2,0,0,1-1.2-1.2V46.63A0,0,0,0,1,38.56,46.63Z" />
        <path
          class="cls-2"
          d="M39.76,75.61H60.82a1.2,1.2,0,0,1,1.2,1.2v1.56a0,0,0,0,1,0,0H38.56a0,0,0,0,1,0,0V76.81A1.2,1.2,0,0,1,39.76,75.61Z" />
        <path
          class="cls-2"
          d="M62.82,79.32a.6.6,0,0,0,.06-.62.62.62,0,0,0-.54-.33H38.23a.6.6,0,0,0-.53.33.58.58,0,0,0,.06.62c1.19,1.58,4.5,4.57,12.53,4.57S61.63,80.9,62.82,79.32Z" />
        <rect
          class="cls-2"
          x="42.7"
          y="49.39"
          width="15.18"
          height="26.22" />
        <polygon
          class="cls-3"
          points="53.74 49.39 42.7 60.43 42.7 49.39 53.74 49.39" />
        <polygon
          class="cls-3"
          points="46.84 75.61 57.88 64.57 57.88 75.61 46.84 75.61" />
        <polygon
          class="cls-3"
          points="42.7 73.54 57.88 58.36 57.88 51.46 42.7 66.64 42.7 73.54" />
        <path
          class="cls-4"
          d="M38.56,46.63H62a0,0,0,0,1,0,0v1.56a1.2,1.2,0,0,1-1.2,1.2H39.76a1.2,1.2,0,0,1-1.2-1.2V46.63A0,0,0,0,1,38.56,46.63Z" />
        <path
          class="cls-4"
          d="M39.76,75.61H60.82a1.2,1.2,0,0,1,1.2,1.2v1.56a0,0,0,0,1,0,0H38.56a0,0,0,0,1,0,0V76.81A1.2,1.2,0,0,1,39.76,75.61Z" />
        <path
          class="cls-4"
          d="M62.82,79.32a.58.58,0,0,0,0-.62.59.59,0,0,0-.53-.33H38.24a.59.59,0,0,0-.53.33.58.58,0,0,0,0,.62c1.2,1.59,4.51,4.57,12.53,4.57S61.63,80.9,62.82,79.32Z" />
        <rect
          class="cls-4"
          x="39.94"
          y="49.39"
          width="20.7"
          height="26.22" />
        <rect
          class="cls-4"
          x="42.7"
          y="49.39"
          width="15.18"
          height="26.22" />
        <polygon
          class="cls-4"
          points="53.74 49.39 42.7 60.43 42.7 49.39 53.74 49.39" />
        <polygon
          class="cls-4"
          points="46.84 75.61 57.88 64.57 57.88 75.61 46.84 75.61" />
        <polygon
          class="cls-4"
          points="42.7 73.54 57.88 58.36 57.88 51.46 42.7 66.64 42.7 73.54" />
        <path
          class="cls-2"
          d="M63.4,46.17a2.3,2.3,0,0,0-2.3-2.3H39.48a2.3,2.3,0,0,0-2.3,2.3.47.47,0,0,0,.46.46h25.3A.47.47,0,0,0,63.4,46.17Z" />
        <rect
          class="cls-2"
          x="43.39"
          y="41.11"
          width="13.8"
          height="2.76" />
        <path
          class="cls-4"
          d="M63.4,46.17a2.3,2.3,0,0,0-2.3-2.3H39.48a2.3,2.3,0,0,0-2.3,2.3.47.47,0,0,0,.46.46h25.3A.47.47,0,0,0,63.4,46.17Z" />
        <rect
          class="cls-4"
          x="43.39"
          y="41.11"
          width="13.8"
          height="2.76" />
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
  @use '@/styles/variables' as *;

  .cls-1 {
    fill: var(--iconColorExtraLight);
  }
  .cls-2 {
    fill: #fff;
  }
  .cls-3 {
    fill: var(--iconColorLight);
  }
  .cls-4 {
    fill: none;
    stroke: var(--iconColor);
    stroke-linecap: round;
    stroke-linejoin: round;
  }
</style>
